export default __webpack_public_path__ + "static/element-swirl-8819dbcd3671053d85a79c329164cd5b.svg";